import { pgTable, text, primaryKey, unique, boolean, } from 'drizzle-orm/pg-core';
import { isoTimestamp, tableBase } from '../utils';
export const Org = pgTable('org', {
    ...tableBase,
    name: text('name').notNull(),
    isActive: boolean('is_active').notNull(),
    axleOrgId: text('axle_org_id').notNull(),
    lastSyncedAt: isoTimestamp('last_synced_at'),
    imageUrl: text('image_url'),
}, (table) => ({
    pk: primaryKey({ columns: [table.id] }),
    uq: unique().on(table.axleOrgId),
}));
//# sourceMappingURL=org.js.map